const comments = [
  {
    name: '吃瓜不嫌事大',
    avatar: 'https://readdy.ai/api/search-image?query=Abstract%20warm%20toned%20circular%20avatar%20with%20soft%20geometric%20patterns%20in%20amber%20and%20cream%2C%20minimalist%20design%20with%20subtle%20texture&width=100&height=100&seq=avatar-01-2026&orientation=squarish',
    text: '这个瓜真的太大了！每天蹲在911爆料网刷更新，比追剧还上瘾，信息更新速度也快，赞一个！',
    time: '2分钟前',
    likes: 1286,
  },
  {
    name: '深夜吃瓜人',
    avatar: 'https://readdy.ai/api/search-image?query=Abstract%20warm%20crimson%20circular%20avatar%20with%20minimalist%20geometric%20shapes%2C%20soft%20gradient%20background%20with%20subtle%20texture%20and%20warm%20tones&width=100&height=100&seq=avatar-02-2026&orientation=squarish',
    text: '看了这么多爆料平台，还是911的最靠谱，至少每条都有证据链，不是那种无脑编故事的。',
    time: '15分钟前',
    likes: 956,
  },
  {
    name: '八卦研究员',
    avatar: 'https://readdy.ai/api/search-image?query=Abstract%20dark%20red%20circular%20avatar%20with%20simple%20geometric%20design%2C%20warm%20gradient%20with%20subtle%20pattern%2C%20minimalist%20and%20modern%20style&width=100&height=100&seq=avatar-03-2026&orientation=squarish',
    text: '911爆料网的评论区氛围真的太好了，大家都是理性吃瓜，不像其他地方全是键盘侠和喷子。',
    time: '32分钟前',
    likes: 723,
  },
  {
    name: '瓜田守望者',
    avatar: 'https://readdy.ai/api/search-image?query=Abstract%20amber%20toned%20circular%20avatar%20with%20minimalist%20geometric%20shapes%2C%20warm%20soft%20background%20with%20subtle%20texture%2C%20clean%20modern%20design&width=100&height=100&seq=avatar-04-2026&orientation=squarish',
    text: '已经推荐给身边所有爱吃瓜的朋友了，911爆料网简直是吃瓜界的权威媒体！希望越做越好。',
    time: '1小时前',
    likes: 1542,
  },
  {
    name: '真相挖掘机',
    avatar: 'https://readdy.ai/api/search-image?query=Abstract%20warm%20orange%20circular%20avatar%20with%20simple%20geometric%20pattern%2C%20soft%20gradient%20background%2C%20minimalist%20modern%20design%20with%20subtle%20texture&width=100&height=100&seq=avatar-05-2026&orientation=squarish',
    text: '从20年开始关注911，见证了平台的成长。现在每天打开手机第一件事就是来911看有没有新爆料，已经成习惯了。',
    time: '2小时前',
    likes: 891,
  },
];

export default function Comments() {
  return (
    <section id="comments" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <span className="text-sm text-secondary-600 font-medium bg-secondary-50 px-3 py-1 rounded-full">读者声音</span>
          <h2 className="mt-3 text-2xl md:text-3xl font-heading font-bold text-foreground-950">网友热议</h2>
          <p className="mt-2 text-sm text-foreground-500">听听吃瓜群众怎么说</p>
        </div>

        <div className="max-w-4xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-5">
          {comments.map((comment, index) => (
            <div key={index} className={`bg-background-50 border border-background-200/70 rounded-xl p-5 ${index === 0 ? 'md:col-span-2' : ''}`}>
              <div className="flex items-start gap-3">
                <div className="flex-shrink-0 w-10 h-10 rounded-full bg-background-200 overflow-hidden">
                  <img src={comment.avatar} alt={comment.name} className="w-full h-full object-cover" />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="text-sm font-medium text-foreground-800 whitespace-nowrap">{comment.name}</span>
                    <span className="text-xs text-foreground-400 whitespace-nowrap">{comment.time}</span>
                  </div>
                  <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{comment.text}</p>
                  <div className="mt-3 flex items-center gap-4">
                    <button className="flex items-center gap-1.5 text-xs text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">
                      <i className="ri-thumb-up-line"></i> {comment.likes}
                    </button>
                    <button className="flex items-center gap-1.5 text-xs text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">
                      <i className="ri-chat-3-line"></i> 回复
                    </button>
                    <button className="flex items-center gap-1.5 text-xs text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">
                      <i className="ri-share-line"></i> 分享
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}